import { FC } from 'react';

import { Pill, PillProps } from '~/core/shared/components';
import { DocumentStatusResource, StatusResource } from '~/core/shared/types';

type StatusProps = {
  status?: DocumentStatusResource | StatusResource;
  defaultLabel?: string;
  colorPalette?: string;
} & Omit<PillProps, 'label'>;

export const Status: FC<StatusProps> = ({
  status,
  defaultLabel = 'Open',
  colorPalette = 'gray',
  ...props
}) => {
  const label = status?.title || defaultLabel;

  return <Pill {...{ ...props, colorPalette, label }} />;
};
